/**
 * Registry lookups by path. Free of native-navigation imports on purpose: importing
 * `nativeNavigation/init.ts` runs plugin init as a side effect.
 */
import { routes } from "./registry";
import type { RouteNode } from "./route";

/** A registry leaf: it carries a concrete `path` and a `build()`, unlike grouping objects. */
function isRouteNode(value: unknown): value is RouteNode {
  return (
    !!value &&
    typeof value === "object" &&
    typeof (value as RouteNode).path === "string" &&
    typeof (value as { build?: unknown }).build === "function"
  );
}

function collectRouteNodes(group: object, acc: RouteNode[] = []): RouteNode[] {
  for (const value of Object.values(group)) {
    if (isRouteNode(value)) {
      acc.push(value);
    } else if (value && typeof value === "object") {
      collectRouteNodes(value, acc);
    }
  }
  return acc;
}

/** Every route node in the registry, regardless of nesting depth. */
export const allRouteNodes = collectRouteNodes(routes);
